import MapWithMarkersStore from "@lib-shared/stores/map/map-with-markers.store";
import { ModalAlert } from "@shared/lib/show-modal";
import { convertAll } from "core/models/search-result-item";
import { lookupCitiesService, lookupCityCoordinatesService, lookupDealersService, lookupInstallersService } from "core/services";
import SearchStore, { DisplayMode } from "core/stores/search.store";

const useSearchLogic = (store: SearchStore, mapStore: MapWithMarkersStore) => {
  const fetchCitiesAsync = async () => {
    try {
      const cities = await lookupCitiesService.get(store.country);
      store.updateCities(cities);
      store.updateIsLoading(false);
    } catch (error) {
      console.error(`There has been an error fetching cities for ${store.country}`, error);
    }
  };

  const filterCities = (needle: string) => {
    //could debounce
    store.updateFilter(needle);

    const filtered = store.cities.filter(x => x.toLowerCase().includes(needle));
    const limited = filtered.slice(0, 5);

    store.updateFilteredCities(limited);
  }

  const useMyLocation = () => {
    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition((position) => {
      let coords = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };

      mapStore.updateCenter(coords);
    });
  }

  const clearFilter = () => {
    store.reset();

    const input = document.querySelector(".search-input input") as HTMLInputElement;
    input.value = "";
    input.focus();
  }

  const lookupCityCoordinates = async () => {
    const coords = await lookupCityCoordinatesService.get({ city: store.city, country: store.country });
    mapStore.updateCenter(coords);
  }

  const selectCityAsync = async (el: HTMLElement, city: string) => {
    store.updateCity(city);
    store.updateIsLoading(true);

    const activeCss = "active";
    document.querySelectorAll(`ul.cities li.${activeCss}`).forEach(x => x.classList.remove(activeCss));

    el.classList.add(activeCss);

    const params = { country: store.country, city };

    try {
      const [installers, dealers] = await Promise.all([
        lookupInstallersService.get(city, params),
        lookupDealersService.get(city, params)
      ]);

      store.updateDealersAndInstallers(convertAll(dealers), convertAll(installers))

      // const markers: MapMarker[] = []

      // const allResults = [...result, ...result2];

      // allResults.forEach(x => {
      //     let marker: MapMarker = {
      //         title: x.name,
      //         position: x.coords
      //     };
      //     markers.push(marker);
      // });

      // mapStore.updateMarkers(markers);

      try {
        await lookupCityCoordinates();
      } catch (error) {
        console.error("Error looking up city coordinates", error);
      }

      store.updateIsLoading(false);
    } catch (error) {
      ModalAlert.error("Sorry there have been a problem finding installers. Please try again.");

      console.error(error);
    }

    store.updateIsLoading(false);
  }

  const _getResultsToShow = () => {
    switch (store.displayMode) {
      case DisplayMode.All:
        return [...store.dealers, ...store.installers];
      case DisplayMode.Dealers:
        return [...store.dealers];
      case DisplayMode.Installers:
        return [...store.installers];
    }
  }

  const getResultsToShow = () => {
    return _getResultsToShow().splice(0, store.numberOfResultsToShow);
  }

  return {
    filterCities,
    useMyLocation,
    fetchCitiesAsync,
    clearFilter,
    selectCityAsync,
    getResultsToShow
  }
}

export default useSearchLogic;
